import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"position":"fixed","right":"60px","bottom":"60px","z-index":"10"}
}
const _hoisted_2 = {
  colspan: 1,
  style: {"width":"64px"}
}
const _hoisted_3 = { class: "d-flex align-center justify-center" }
const _hoisted_4 = ["colspan"]
const _hoisted_5 = { style: {"white-space":"nowrap"} }
const _hoisted_6 = ["data-cy", "onClick"]
const _hoisted_7 = {
  class: "text-center",
  style: {"width":"64px"}
}
const _hoisted_8 = { class: "d-flex align-center justify-center" }
const _hoisted_9 = { class: "pl-2 pr-2 text-center" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "body-1" }
const _hoisted_12 = {
  key: 0,
  class: "pl-0 pr-2 text-center"
}
const _hoisted_13 = {
  key: 1,
  style: {"cursor":"pointer","text-align":"center"},
  class: "px-0 text-center"
}
const _hoisted_14 = {
  key: 2,
  class: "px-0 text-center"
}
const _hoisted_15 = {
  key: 3,
  style: {"text-align":"center"},
  class: "px-0 text-center"
}
const _hoisted_16 = { class: "px-0 text-center" }
const _hoisted_17 = {
  key: 4,
  class: "pr-1 text-center"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["colspan"]
const _hoisted_21 = { style: {"white-space":"nowrap"} }
const _hoisted_22 = ["onClick", "data-cy"]
const _hoisted_23 = {
  key: 0,
  class: "px-0 text-center"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "px-0 text-left" }
const _hoisted_26 = { class: "pr-0 text-left" }
const _hoisted_27 = { class: "pr-0 text-left" }
const _hoisted_28 = {
  key: 2,
  class: "pr-2"
}
const _hoisted_29 = { style: {"min-width":"100px","max-width":"600px","overflow":"hidden","white-space":"nowrap","text-overflow":"ellipsis"} }
const _hoisted_30 = { class: "font-weight-bold" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "text-center" }
const _hoisted_33 = { class: "text-center" }
const _hoisted_34 = { class: "text-center" }
const _hoisted_35 = {
  key: 0,
  style: {"height":"60vh"},
  class: "pa-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_oss_filter_bar = _resolveComponent("oss-filter-bar")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_AuditCheckAlertButton = _resolveComponent("AuditCheckAlertButton")!
  const _component_AuditCheckDocumentDialog = _resolveComponent("AuditCheckDocumentDialog")!
  const _component_TutorialButtonDialog = _resolveComponent("TutorialButtonDialog")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_speed_dial = _resolveComponent("v-speed-dial")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_btn_ternary = _resolveComponent("v-btn-ternary")!
  const _component_DocumentMultipleAnalysis = _resolveComponent("DocumentMultipleAnalysis")!
  const _component_multiple_free_tagging = _resolveComponent("multiple-free-tagging")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_chip_tag = _resolveComponent("v-chip-tag")!
  const _component_FreeTag = _resolveComponent("FreeTag")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_oss_card = _resolveComponent("oss-card")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_DocumentWizardDialog = _resolveComponent("DocumentWizardDialog")!
  const _component_ImportStripe = _resolveComponent("ImportStripe")!
  const _component_AccountingItemEdition2 = _resolveComponent("AccountingItemEdition2")!
  const _component_company_table = _resolveComponent("company-table")!
  const _component_oss_widget_embedder = _resolveComponent("oss-widget-embedder")!
  const _component_SalesInvoice = _resolveComponent("SalesInvoice")!
  const _component_upload_documents_from_mail = _resolveComponent("upload-documents-from-mail")!
  const _component_Subscriptions = _resolveComponent("Subscriptions")!
  const _component_ImportBankMain = _resolveComponent("ImportBankMain")!
  const _component_v_container = _resolveComponent("v-container")!
  const _directive_tooltip = _resolveDirective("tooltip")!
  const _directive_intersect = _resolveDirective("intersect")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: "",
    style: _normalizeStyle({ height: _ctx.containerHeight })
  }, {
    default: _withCtx(() => [
      (_ctx.currentUser.profile && _ctx.isAuthorized)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "my-3 justify-center"
            }, {
              default: _withCtx(() => [
                (!_ctx.isAutonomousUser && !_ctx.selectMode)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      cols: "2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_menu, {
                          "open-on-hover": "",
                          "offset-y": "",
                          location: "bottom"
                        }, {
                          activator: _withCtx(({ props }) => [
                            (!_ctx.$vuetify.display.mobile)
                              ? (_openBlock(), _createBlock(_component_v_btn_primary, _mergeProps({ key: 0 }, props, {
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openDocumentWizard())),
                                  elevation: "0",
                                  block: "",
                                  id: "AddDocumentBtn",
                                  disabled: !!_ctx.auditCheck,
                                  "data-cy": "documentsTable-add"
                                }), {
                                  default: _withCtx(() => _cache[75] || (_cache[75] = [
                                    _createTextVNode(" Ajouter ")
                                  ])),
                                  _: 2
                                }, 1040, ["disabled"]))
                              : _createCommentVNode("", true)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list, { nav: "" }, {
                              default: _withCtx(() => [
                                (
                                    _ctx.currentUser.profile.configuration.document.importPurchaseInvoice
                                )
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 0,
                                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.startUpload('PURCHASE_INVOICE'))),
                                      title: "Importer un fichier d'achat"
                                    }, {
                                      append: _withCtx(() => [
                                        _createVNode(_component_v_icon, { size: "x-small" }, {
                                          default: _withCtx(() => _cache[76] || (_cache[76] = [
                                            _createTextVNode("$fa-chevron-right")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.currentUser.profile.configuration.document.importSalesInvoice)
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 1,
                                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.startUpload('SALES_INVOICE'))),
                                      title: "Importer un fichier de vente"
                                    }, {
                                      append: _withCtx(() => [
                                        _createVNode(_component_v_icon, { size: "x-small" }, {
                                          default: _withCtx(() => _cache[77] || (_cache[77] = [
                                            _createTextVNode("$fa-chevron-right")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (
                                    _ctx.currentUser.profile.configuration.document
                                        .importMultiSalesInvoice
                                )
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 2,
                                      "two-line": "",
                                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeSaleInvoices = true)),
                                      title: "Importer un fichier de ventes",
                                      subtitle: "fichier .csv"
                                    }, {
                                      append: _withCtx(() => [
                                        _createVNode(_component_v_icon, { size: "x-small" }, {
                                          default: _withCtx(() => _cache[78] || (_cache[78] = [
                                            _createTextVNode("$fa-chevron-right")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (
                                    _ctx.currentUser.profile.configuration.document
                                        .importPurchaseInvoice && _ctx.declareSalesInvoices
                                )
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 3,
                                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.startUpload('CURRENT_ACCOUNT'))),
                                      title: "Importer une facture en compte courant"
                                    }, {
                                      append: _withCtx(() => [
                                        _createVNode(_component_v_icon, { size: "x-small" }, {
                                          default: _withCtx(() => _cache[79] || (_cache[79] = [
                                            _createTextVNode("$fa-chevron-right")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (
                                    _ctx.currentUser.profile.configuration.document
                                        .importPurchaseInvoice && !_ctx.declareSalesInvoices
                                )
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 4,
                                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.startUpload('OPERATOR_ACCOUNT'))),
                                      title: "Importer une facture en compte de l'exploitant"
                                    }, {
                                      append: _withCtx(() => [
                                        _createVNode(_component_v_icon, { size: "x-small" }, {
                                          default: _withCtx(() => _cache[80] || (_cache[80] = [
                                            _createTextVNode("$fa-chevron-right")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (
                                    _ctx.currentUser.profile.configuration.document
                                        .importPurchaseInvoice &&
                                    _ctx.selectedCompany.solution === 'MANAGEMENT'
                                )
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 5,
                                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.startUpload('PAY_SLIP'))),
                                      title: "Importer un fichier de fiche de paie"
                                    }, {
                                      append: _withCtx(() => [
                                        _createVNode(_component_v_icon, { size: "x-small" }, {
                                          default: _withCtx(() => _cache[81] || (_cache[81] = [
                                            _createTextVNode("$fa-chevron-right")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (
                                    _ctx.currentUser.profile.configuration.document.importPurchaseInvoice
                                )
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 6,
                                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.startUpload('MISCELLANEOUS'))),
                                      title: "Importer un fichier divers"
                                    }, {
                                      append: _withCtx(() => [
                                        _createVNode(_component_v_icon, { size: "x-small" }, {
                                          default: _withCtx(() => _cache[82] || (_cache[82] = [
                                            _createTextVNode("$fa-chevron-right")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (
                                    _ctx.currentUser.profile.configuration.document.importPurchaseInvoice
                                )
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 7,
                                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.startUpload('UNKNOWN'))),
                                      title: "Importer un fichier à découper"
                                    }, {
                                      append: _withCtx(() => [
                                        _createVNode(_component_v_icon, { size: "x-small" }, {
                                          default: _withCtx(() => _cache[83] || (_cache[83] = [
                                            _createTextVNode("$fa-chevron-right")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.isAccountingUser)
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 8,
                                      onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.uploadDocumentsFromMailDialog = true), ["stop"])),
                                      title: "A partir des mails"
                                    }, {
                                      append: _withCtx(() => [
                                        _createVNode(_component_v_icon, { size: "x-small" }, {
                                          default: _withCtx(() => _cache[84] || (_cache[84] = [
                                            _createTextVNode("$fa-chevron-right")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_list_item, {
                                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.subscriptionsDialog = true)),
                                  title: "Abonnement"
                                }, {
                                  append: _withCtx(() => [
                                    _createVNode(_component_v_icon, { size: "x-small" }, {
                                      default: _withCtx(() => _cache[85] || (_cache[85] = [
                                        _createTextVNode("$fa-chevron-right")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                (_ctx.currentUser.profile.configuration.bankTransaction.import)
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 9,
                                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.openBankImportMain())),
                                      title: "Importer des relevés bancaires"
                                    }, {
                                      append: _withCtx(() => [
                                        _createVNode(_component_v_icon, { size: "x-small" }, {
                                          default: _withCtx(() => _cache[86] || (_cache[86] = [
                                            _createTextVNode("$fa-chevron-right")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.isAccountingUser)
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 10,
                                      onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.openLoanPage()), ["stop"])),
                                      title: "Emprunt"
                                    }, {
                                      append: _withCtx(() => [
                                        _createVNode(_component_v_icon, { size: "x-small" }, {
                                          default: _withCtx(() => _cache[87] || (_cache[87] = [
                                            _createTextVNode("$fa-chevron-right")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.isAccountingUser)
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 11,
                                      onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.openLeasingPage()), ["stop"])),
                                      title: "Crédit-Bail"
                                    }, {
                                      append: _withCtx(() => [
                                        _createVNode(_component_v_icon, { size: "x-small" }, {
                                          default: _withCtx(() => _cache[88] || (_cache[88] = [
                                            _createTextVNode("$fa-chevron-right")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.extensionsDialog.length)
                                  ? (_openBlock(), _createBlock(_component_v_divider, { key: 12 }))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.extensionsDialog, (ext) => {
                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                    onClick: 
                                    () => {
                                        _ctx.widgetDialog = true;
                                        _ctx.activeExtension = ext;
                                    }
                                ,
                                    key: ext.id,
                                    title: ext.name
                                  }, {
                                    append: _withCtx(() => [
                                      _createVNode(_component_v_icon, { size: "x-small" }, {
                                        default: _withCtx(() => _cache[89] || (_cache[89] = [
                                          _createTextVNode("$fa-chevron-right")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick", "title"]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_col, {
                  cols: _ctx.$vuetify.display.mobile ? '12' : _ctx.showTotal ? '6' : '8',
                  class: "pl-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_oss_filter_bar, {
                      mode: "document",
                      type: _ctx.type,
                      "onUpdate:type": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.type) = $event)),
                      text: _ctx.search,
                      "onUpdate:text": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.search) = $event)),
                      tags: _ctx.documentTags,
                      "onUpdate:tags": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.documentTags) = $event)),
                      startDate: _ctx.beginDate,
                      "onUpdate:startDate": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.beginDate) = $event)),
                      endDate: _ctx.endDate,
                      "onUpdate:endDate": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.endDate) = $event)),
                      status: _ctx.documentStatus,
                      "onUpdate:status": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.documentStatus) = $event)),
                      declaredStatus: _ctx.declaredStatus,
                      "onUpdate:declaredStatus": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.declaredStatus) = $event)),
                      thirdPartyCompanyName: _ctx.thirdPartyCompanyName,
                      "onUpdate:thirdPartyCompanyName": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.thirdPartyCompanyName) = $event)),
                      minPrice: _ctx.minAmount,
                      "onUpdate:minPrice": _cache[22] || (_cache[22] = ($event: any) => (
                            _ctx.documentType === 'PURCHASE_INVOICE'
                                ? (_ctx.maxAmount = -$event + '')
                                : (_ctx.minAmount = $event + '')
                        )),
                      maxPrice: _ctx.maxAmount,
                      "onUpdate:maxPrice": _cache[23] || (_cache[23] = ($event: any) => (
                            _ctx.documentType === 'PURCHASE_INVOICE'
                                ? (_ctx.minAmount = -$event + '')
                                : (_ctx.maxAmount = $event + '')
                        )),
                      limitMinPrice: 
                            _ctx.documentType === 'PURCHASE_INVOICE'
                                ? -_ctx.maxDocumentAmount
                                : _ctx.minDocumentAmount
                        ,
                      limitMaxPrice: 
                            _ctx.documentType === 'PURCHASE_INVOICE'
                                ? -_ctx.minDocumentAmount
                                : _ctx.maxDocumentAmount
                        ,
                      "types-list": 
                            _ctx.documentTypes.map((type) => {
                                return { value: type, text: _ctx.formatType(type) };
                            })
                        ,
                      "status-list": 
                            _ctx.allDocumentStatus.map((type) => {
                                return { value: type, text: _ctx.formatStatus(type) };
                            })
                        ,
                      companyId: _ctx.selectedCompany.id,
                      auditCheck: _ctx.auditCheck,
                      "onUpdate:auditCheck": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.auditCheck) = $event)),
                      auditChecks: _ctx.documentType !== 'MAIL' ? _ctx.auditChecks : null,
                      partitionTagId: _ctx.partitionTagId,
                      "onUpdate:partitionTagId": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.partitionTagId) = $event)),
                      partitionTags: _ctx.partitionTags,
                      "data-cy": "DocumentsTable-filterBar"
                    }, null, 8, ["type", "text", "tags", "startDate", "endDate", "status", "declaredStatus", "thirdPartyCompanyName", "minPrice", "maxPrice", "limitMinPrice", "limitMaxPrice", "types-list", "status-list", "companyId", "auditCheck", "auditChecks", "partitionTagId", "partitionTags"])
                  ]),
                  _: 1
                }, 8, ["cols"]),
                (_ctx.showTotal)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 1,
                      cols: "2",
                      class: "pl-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          outlined: "",
                          readonly: "",
                          "model-value": 'Total : ' + _ctx.newCommonFormatCurrency(_ctx.amountSum, undefined)
                        }, null, 8, ["model-value"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.$vuetify.display.mobile)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 2,
                      cols: "2",
                      class: "d-flex justify-end"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.auditCheckDocumentsWithAnomalyCount > 0)
                          ? (_openBlock(), _createBlock(_component_AuditCheckAlertButton, {
                              key: 0,
                              count: _ctx.auditCheckDocumentsWithAnomalyCount,
                              auditCheckType: "Document",
                              onAuditCheckAlertButtonClicked: _ctx.onAuditCheckAlertButtonClicked
                            }, null, 8, ["count", "onAuditCheckAlertButtonClicked"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_AuditCheckDocumentDialog, {
                          modelValue: _ctx.shouldAuditCheckDocumentDialogBeVisible,
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.shouldAuditCheckDocumentDialogBeVisible) = $event)),
                          auditChecks: _ctx.auditCheckDocumentsWithAnomaly,
                          companyId: _ctx.selectedCompany.id
                        }, null, 8, ["modelValue", "auditChecks", "companyId"]),
                        _createVNode(_component_TutorialButtonDialog, { starterComponents: 'DocumentsTable;' })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (_ctx.$vuetify.display.mobile)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(_component_v_speed_dial, {
                    modelValue: _ctx.mobileDocumentDial,
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.mobileDocumentDial) = $event)),
                    location: "top center",
                    transition: "slide-y-transition"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _withDirectives(_createVNode(_component_v_btn, _mergeProps({
                        fab: "",
                        style: {"float":"right","box-shadow":"10px 10px 7px rgba(0, 0, 0, 0.06)"},
                        size: "small",
                        icon: _ctx.mobileDocumentDial ? '$oss-close' : '$add'
                      }, props), null, 16, ["icon"]), [
                        [_vShow, !_ctx.importDocument]
                      ])
                    ]),
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_v_btn, {
                        key: "1",
                        size: "small",
                        fab: "",
                        color: "primary",
                        style: {"float":"right","box-shadow":"10px 10px 7px rgba(0, 0, 0, 0.06)"},
                        onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.openDocumentWizard())),
                        icon: "$add"
                      }, null, 512), [
                        [_vShow, !_ctx.importDocument]
                      ]),
                      _withDirectives(_createVNode(_component_v_btn, {
                        key: "2",
                        size: "small",
                        fab: "",
                        color: "primary",
                        style: {"float":"right","box-shadow":"10px 10px 7px rgba(0, 0, 0, 0.06)"},
                        onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.startUpload('PURCHASE_INVOICE'))),
                        icon: "$note-frais"
                      }, null, 512), [
                        [_vShow, !_ctx.importDocument]
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.$vuetify.display.mobile)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.documentType !== 'MAIL')
                    ? (_openBlock(), _createBlock(_component_v_data_table_server, {
                        key: 0,
                        headers: _ctx.headers,
                        items: _ctx.documents,
                        page: _ctx.pagination.page,
                        "sort-by": _ctx.pagination.sortBy,
                        "sort-desc": _ctx.pagination.descending,
                        "items-per-page": _ctx.pagination.rowsPerPage,
                        "items-length": _ctx.pagination?.totalItems || 0,
                        "items-per-page-options": [5, 10, 25],
                        loading: _ctx.loading,
                        class: "table rounded-lg",
                        "hide-default-footer": "",
                        "fixed-header": "",
                        height: _ctx.selectMode ? '60vh' : '76vh',
                        style: {"min-width":"1150px"}
                      }, {
                        headers: _withCtx(({ columns: headers }) => [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", _hoisted_2, [
                              _createElementVNode("div", _hoisted_3, [
                                _createVNode(_component_v_checkbox, {
                                  modelValue: _ctx.isAllSelected,
                                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.isAllSelected) = $event)),
                                  indeterminate: _ctx.isIndeterminate,
                                  color: "primary",
                                  density: "compact",
                                  "hide-details": ""
                                }, null, 8, ["modelValue", "indeterminate"])
                              ])
                            ]),
                            _createElementVNode("th", {
                              colspan: headers.length,
                              style: {"padding-left":"0"}
                            }, [
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "flex-nowrap"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "6",
                                    class: "d-flex align-center space-x-2 flex-grow-1 flex-shrink-0"
                                  }, {
                                    default: _withCtx(() => [
                                      (_ctx.isAccountingUser && !_ctx.selectMode)
                                        ? (_openBlock(), _createBlock(_component_v_btn_ternary, {
                                            key: 0,
                                            onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.dialogChangeThirdPartyCompanyDocument = true)),
                                            disabled: !_ctx.onlyPurchasesSelected
                                          }, {
                                            default: _withCtx(() => _cache[90] || (_cache[90] = [
                                              _createTextVNode(" Fournisseur ")
                                            ])),
                                            _: 1
                                          }, 8, ["disabled"]))
                                        : _createCommentVNode("", true),
                                      (_ctx.isAccountingUser && !_ctx.selectMode)
                                        ? (_openBlock(), _createBlock(_component_v_btn_ternary, {
                                            key: 1,
                                            onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.dialogChangeThirdPartyCompanyDocument = true)),
                                            disabled: !_ctx.onlySalesSelected,
                                            class: "ml-2"
                                          }, {
                                            default: _withCtx(() => _cache[91] || (_cache[91] = [
                                              _createTextVNode(" Client ")
                                            ])),
                                            _: 1
                                          }, 8, ["disabled"]))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_DocumentMultipleAnalysis, {
                                        "is-enable": _ctx.documentMultipleAnaysisPossible,
                                        documents: _ctx.selectedDocuments
                                      }, null, 8, ["is-enable", "documents"]),
                                      (
                                                _ctx.isAccountingUser &&
                                                _ctx.enableMultiValidation &&
                                                !_ctx.selectMode
                                            )
                                        ? (_openBlock(), _createBlock(_component_v_btn_ternary, {
                                            key: 2,
                                            onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.multiValidationDialog = true)),
                                            disabled: !_ctx.onlyToValidateOKSelected,
                                            class: "ml-2"
                                          }, {
                                            default: _withCtx(() => _cache[92] || (_cache[92] = [
                                              _createTextVNode(" Valider ")
                                            ])),
                                            _: 1
                                          }, 8, ["disabled"]))
                                        : _createCommentVNode("", true),
                                      (!_ctx.selectMode)
                                        ? (_openBlock(), _createBlock(_component_multiple_free_tagging, {
                                            key: 3,
                                            company: _ctx.selectedCompany,
                                            "company-tags": _ctx.allCompanyTags,
                                            "selected-documents": _ctx.selectedDocuments,
                                            onSelectedTags: _ctx.onMultiTagguingApplied
                                          }, null, 8, ["company", "company-tags", "selected-documents", "onSelectedTags"]))
                                        : _createCommentVNode("", true),
                                      (!_ctx.selectMode)
                                        ? (_openBlock(), _createBlock(_component_v_menu, {
                                            key: 4,
                                            "offset-y": ""
                                          }, {
                                            activator: _withCtx(({ props }) => [
                                              _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$dots_vertical" }, props, { loading: _ctx.menuLoading }), null, 16, ["loading"])
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list, null, {
                                                default: _withCtx(() => [
                                                  (_ctx.showActionIgnoreDuplicates)
                                                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                        key: 0,
                                                        onClick: _ctx.ignoreSelectedDuplicatedDocuments,
                                                        disabled: !_ctx.isActionIgnoreDuplicatesEnabled
                                                      }, {
                                                        append: _withCtx(() => [
                                                          _createVNode(_component_v_icon, { size: "small" }, {
                                                            default: _withCtx(() => _cache[94] || (_cache[94] = [
                                                              _createTextVNode("$oss-close")
                                                            ])),
                                                            _: 1
                                                          })
                                                        ]),
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_list_item_title, null, {
                                                            default: _withCtx(() => _cache[93] || (_cache[93] = [
                                                              _createTextVNode(" Ignorer les doublons sélectionnés ")
                                                            ])),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      }, 8, ["onClick", "disabled"]))
                                                    : _createCommentVNode("", true),
                                                  (_ctx.showActionHideOrShowIgnoredDuplicates)
                                                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                        key: 1,
                                                        onClick: _ctx.toggleShowIgnoredAuditChecks
                                                      }, {
                                                        append: _withCtx(() => [
                                                          (!_ctx.showIgnoredAuditChecks)
                                                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                                                key: 0,
                                                                size: "small"
                                                              }, {
                                                                default: _withCtx(() => _cache[95] || (_cache[95] = [
                                                                  _createTextVNode(" $oss-eye ")
                                                                ])),
                                                                _: 1
                                                              }))
                                                            : (_openBlock(), _createBlock(_component_v_icon, {
                                                                key: 1,
                                                                size: "small"
                                                              }, {
                                                                default: _withCtx(() => _cache[96] || (_cache[96] = [
                                                                  _createTextVNode(" $oss-eye-slash ")
                                                                ])),
                                                                _: 1
                                                              }))
                                                        ]),
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_list_item_title, null, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(_toDisplayString(!_ctx.showIgnoredAuditChecks
                                                                ? "Afficher les doublons ignorés"
                                                                : "Masquer les doublons ignorés"), 1)
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      }, 8, ["onClick"]))
                                                    : _createCommentVNode("", true),
                                                  (
                                                        _ctx.showActionIgnoreDuplicates ||
                                                        _ctx.showActionHideOrShowIgnoredDuplicates
                                                    )
                                                    ? (_openBlock(), _createBlock(_component_v_divider, { key: 2 }))
                                                    : _createCommentVNode("", true),
                                                  _createVNode(_component_v_list_item, {
                                                    onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.showTag = !_ctx.showTag))
                                                  }, {
                                                    append: _withCtx(() => [
                                                      _createVNode(_component_v_icon, { size: "small" }, {
                                                        default: _withCtx(() => _cache[97] || (_cache[97] = [
                                                          _createTextVNode("$oss-eye")
                                                        ])),
                                                        _: 1
                                                      })
                                                    ]),
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_list_item_title, null, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(_ctx.showTag
                                                                ? "Cacher les étiquettes"
                                                                : "Afficher les étiquettes"), 1)
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  }),
                                                  (_ctx.isAccountingUser)
                                                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                        key: 3,
                                                        disabled: _ctx.disabledDownload,
                                                        onClick: _ctx.startDownloadFile
                                                      }, {
                                                        append: _withCtx(() => [
                                                          _createVNode(_component_v_icon, { size: "small" }, {
                                                            default: _withCtx(() => _cache[99] || (_cache[99] = [
                                                              _createTextVNode("$oss-download")
                                                            ])),
                                                            _: 1
                                                          })
                                                        ]),
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_list_item_title, null, {
                                                            default: _withCtx(() => _cache[98] || (_cache[98] = [
                                                              _createTextVNode(" Télécharger ")
                                                            ])),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      }, 8, ["disabled", "onClick"]))
                                                    : _createCommentVNode("", true),
                                                  (_ctx.isAccountingUser)
                                                    ? (_openBlock(), _createBlock(_component_v_divider, { key: 4 }))
                                                    : _createCommentVNode("", true),
                                                  (!_ctx.displayDeletePermanentlyButton)
                                                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                        key: 5,
                                                        disabled: _ctx.disabledDelete,
                                                        color: "error",
                                                        onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.dialogDeleteSelectedDocument = true)),
                                                        active: !_ctx.disabledDelete
                                                      }, {
                                                        append: _withCtx(() => [
                                                          _createVNode(_component_v_icon, { size: "small" }, {
                                                            default: _withCtx(() => _cache[101] || (_cache[101] = [
                                                              _createTextVNode("$delete")
                                                            ])),
                                                            _: 1
                                                          })
                                                        ]),
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_list_item_title, null, {
                                                            default: _withCtx(() => _cache[100] || (_cache[100] = [
                                                              _createTextVNode("Supprimer")
                                                            ])),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      }, 8, ["disabled", "active"]))
                                                    : _createCommentVNode("", true),
                                                  (_ctx.displayDeletePermanentlyButton)
                                                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                        key: 6,
                                                        disabled: _ctx.disabledDeletePermanently,
                                                        color: "red",
                                                        onClick: _cache[36] || (_cache[36] = ($event: any) => (
                                                        _ctx.dialogDeletePermanentlySelectedDocument = true
                                                    )),
                                                        active: !_ctx.disabledDeletePermanently
                                                      }, {
                                                        append: _withCtx(() => [
                                                          _createVNode(_component_v_icon, { size: "small" }, {
                                                            default: _withCtx(() => _cache[103] || (_cache[103] = [
                                                              _createTextVNode("$delete")
                                                            ])),
                                                            _: 1
                                                          })
                                                        ]),
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_list_item_title, null, {
                                                            default: _withCtx(() => _cache[102] || (_cache[102] = [
                                                              _createTextVNode(" Supprimer définitivement ")
                                                            ])),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      }, 8, ["disabled", "active"]))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "6",
                                    class: "d-flex justify-end align-center flex-grow-0 flex-shrink-1 space-x-1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_select, {
                                        modelValue: _ctx.sortBy,
                                        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.sortBy) = $event)),
                                        items: _ctx.sortByList,
                                        style: {"font-size":"0.75rem","width":"min-content"},
                                        "hide-details": "",
                                        "item-value": "key",
                                        "item-title": "text",
                                        label: "Trier par",
                                        outlined: "",
                                        "return-object": "",
                                        density: "compact"
                                      }, null, 8, ["modelValue", "items"]),
                                      _createVNode(_component_v_select, {
                                        modelValue: _ctx.pagination.rowsPerPage,
                                        "onUpdate:modelValue": [
                                          _cache[38] || (_cache[38] = ($event: any) => ((_ctx.pagination.rowsPerPage) = $event)),
                                          _cache[39] || (_cache[39] = ($event: any) => (_ctx.checkMaximumPage()))
                                        ],
                                        items: [5, 10, 25],
                                        "hide-details": "",
                                        outlined: "",
                                        style: {"font-size":"0.75rem","width":"min-content"},
                                        label: "Lignes par page",
                                        density: "compact"
                                      }, null, 8, ["modelValue"]),
                                      _createElementVNode("span", _hoisted_5, _toDisplayString((_ctx.pagination.page - 1) * _ctx.pagination.rowsPerPage + 1) + " - " + _toDisplayString((_ctx.pagination.page - 1) * _ctx.pagination.rowsPerPage +
                                                _ctx.pagination.rowsPerPage) + " de " + _toDisplayString(_ctx.pagination.totalItems), 1),
                                      _createElementVNode("div", null, [
                                        _createVNode(_component_v_btn_prev, {
                                          onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.pagination.page--)),
                                          size: "x-small",
                                          disabled: _ctx.pagination.page === 1
                                        }, null, 8, ["disabled"]),
                                        _createVNode(_component_v_btn_next, {
                                          onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.pagination.page++)),
                                          size: "x-small",
                                          disabled: _ctx.nextPageDisabled
                                        }, null, 8, ["disabled"])
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ], 8, _hoisted_4)
                          ])
                        ]),
                        "no-data": _withCtx(() => _cache[104] || (_cache[104] = [
                          _createTextVNode("Aucune facture déclarée")
                        ])),
                        item: _withCtx((props) => [
                          _createElementVNode("tr", {
                            style: {"cursor":"pointer"},
                            "data-cy": 'documentTable-document-' + props.item.id,
                            onClick: ($event: any) => (
                                _ctx.selectMode
                                    ? _ctx.displayDocumentBeforeSelect(props.item)
                                    : _ctx.openDocument(props.item)
                            )
                          }, [
                            _createElementVNode("td", _hoisted_7, [
                              _createElementVNode("div", _hoisted_8, [
                                _createVNode(_component_v_checkbox, {
                                  onClick: _withModifiers(($event: any) => (
                                            _ctx.selectMode
                                                ? _ctx.addSelectedAuditCheckDocument(props.item)
                                                : _ctx.addSelectedDocument(props.item.id)
                                        ), ["stop"]),
                                  color: "primary",
                                  "hide-details": "",
                                  ripple: false,
                                  "model-value": 
                                            _ctx.selectMode
                                                ? _ctx.isAuditCheckDocumentSelected(props.item.id)
                                                : _ctx.isSelected(props.item.id)
                                        
                                }, null, 8, ["onClick", "model-value"])
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_9, [
                              (!_ctx.isAutonomousUser)
                                ? (_openBlock(), _createElementBlock("b", _hoisted_10, _toDisplayString(_ctx.$t("document.shortType." + props.item.type || "UNKNOWN")), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", {
                              class: _normalizeClass({
                                    'pl-0': true,
                                    'pr-2': true,
                                    'pb-1':
                                        _ctx.currentUser.profile &&
                                        _ctx.currentUser.profile.configuration.tag.write &&
                                        props.item.type !== 'EXPENSE_REPORT_DOCUMENT',
                                    'text-center': _ctx.getDocumentTitle(props.item) === '-',
                                })
                            }, [
                              (_ctx.showTag && props.item.accountingLineTags)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(props.item.accountingLineTags, (tag, index) => {
                                    return (_openBlock(), _createBlock(_component_v_chip_tag, {
                                      ripple: false,
                                      key: index,
                                      class: "text mr-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", {
                                          style: _normalizeStyle('color:' + _ctx.labelTextColor + ';')
                                        }, _toDisplayString(tag.name), 5)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                : _createCommentVNode("", true),
                              (_ctx.getDocumentTitle(props.item) !== '-')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.getDocumentTitle(props.item, false)), 1),
                                    (props.item.uniqueExport && props.item.uniqueExport.id)
                                      ? (_openBlock(), _createBlock(_component_v_icon, {
                                          key: 0,
                                          color: "secondary",
                                          size: "small",
                                          location: "end"
                                        }, {
                                          default: _withCtx(() => _cache[105] || (_cache[105] = [
                                            _createTextVNode("$oss-already-downloaded")
                                          ])),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 2,
                                    color: "primary",
                                    size: "large"
                                  }, {
                                    default: _withCtx(() => _cache[106] || (_cache[106] = [
                                      _createTextVNode("$dot")
                                    ])),
                                    _: 1
                                  })),
                              (
                                        _ctx.showTag &&
                                        _ctx.currentUser.profile.configuration.tag.write &&
                                        props.item.type !== 'EXPENSE_REPORT_DOCUMENT' &&
                                        !_ctx.selectMode
                                    )
                                ? (_openBlock(), _createBlock(_component_FreeTag, {
                                    companyTags: _ctx.allCompanyTags,
                                    document: props.item,
                                    onFocus: _ctx.onFreeTagFocus,
                                    onBlur: _ctx.onFreeTagBlur,
                                    onTagRuleApplyOnThirdPartyCompany: _ctx.refetchDocuments,
                                    key: props.item.id
                                  }, null, 8, ["companyTags", "document", "onFocus", "onBlur", "onTagRuleApplyOnThirdPartyCompany"]))
                                : _createCommentVNode("", true)
                            ], 2),
                            (props.item.invoiceNumber)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_12, _toDisplayString(props.item.invoiceNumber), 1))
                              : (_openBlock(), _createElementBlock("td", _hoisted_13, [
                                  _createVNode(_component_v_icon, {
                                    color: "primary",
                                    size: "large"
                                  }, {
                                    default: _withCtx(() => _cache[107] || (_cache[107] = [
                                      _createTextVNode("$dot")
                                    ])),
                                    _: 1
                                  })
                                ])),
                            (props.item.date)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_14, _toDisplayString(_ctx.formatDate(props.item.date)), 1))
                              : (_openBlock(), _createElementBlock("td", _hoisted_15, [
                                  _createVNode(_component_v_icon, {
                                    color: "primary",
                                    size: "large"
                                  }, {
                                    default: _withCtx(() => _cache[108] || (_cache[108] = [
                                      _createTextVNode("$dot")
                                    ])),
                                    _: 1
                                  })
                                ])),
                            _createElementVNode("td", {
                              style: _normalizeStyle(
                                    _ctx.grossAmountSignedAsValue(props.item) < 0 ? 'color:red;' : ''
                                ),
                              class: "px-0 text-right"
                            }, [
                              (
                                        props.item.type === 'BANK_STATEMENT' ||
                                        props.item.type === 'MISCELLANEOUS'
                                    )
                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 0,
                                    color: "primary",
                                    size: "large"
                                  }, {
                                    default: _withCtx(() => _cache[109] || (_cache[109] = [
                                      _createTextVNode("$dot")
                                    ])),
                                    _: 1
                                  }))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                            _ctx.grossAmountSigned(props.item),
                                            undefined,
                                        )), 1)
                                  ], 64))
                            ], 4),
                            _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.dateFromNow(props.item.updatedAt)), 1),
                            (
                                    _ctx.currentUser.profile &&
                                    _ctx.currentUser.profile.configuration.document.statusDisplay &&
                                    _ctx.selectedCompany.solution !== 'MANAGEMENT'
                                )
                              ? (_openBlock(), _createElementBlock("td", _hoisted_17, [
                                  (props.item.type === 'MISCELLANEOUS')
                                    ? (_openBlock(), _createBlock(_component_v_icon, {
                                        key: 0,
                                        color: "primary",
                                        size: "large"
                                      }, {
                                        default: _withCtx(() => _cache[110] || (_cache[110] = [
                                          _createTextVNode("$dot")
                                        ])),
                                        _: 1
                                      }))
                                    : (_openBlock(), _createBlock(_component_v_chip, {
                                        key: 1,
                                        class: "ma-2",
                                        color: _ctx.statusColor(props.item),
                                        variant: "outlined",
                                        label: "",
                                        size: "small"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.statusTooltip(props.item)), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["color"])),
                                  (props.item.vatDeclaration)
                                    ? _withDirectives((_openBlock(), _createBlock(_component_v_chip, {
                                        key: 2,
                                        class: "ma-2",
                                        color: "green",
                                        variant: "outlined",
                                        label: "",
                                        size: "small"
                                      }, {
                                        default: _withCtx(() => _cache[111] || (_cache[111] = [
                                          _createTextVNode(" Déclaré ")
                                        ])),
                                        _: 2
                                      }, 1024)), [
                                        [_directive_tooltip, _ctx.declaredDateTooltip(props.item)]
                                      ])
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (
                                    _ctx.currentUser.profile &&
                                    _ctx.currentUser.profile.configuration.document.statusDisplay &&
                                    _ctx.selectedCompany.solution !== 'MANAGEMENT'
                                )
                              ? (_openBlock(), _createElementBlock("td", {
                                  key: 5,
                                  class: "pr-1 text-center",
                                  onClick: _withModifiers(($event: any) => (_ctx.openDocument(props.item, true)), ["stop"])
                                }, [
                                  (_ctx.reconciliationIcon(props.item))
                                    ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                        key: 0,
                                        location: "start"
                                      }, {
                                        activator: _withCtx(({ props: ttProps }) => [
                                          _createVNode(_component_v_icon, _mergeProps(ttProps, {
                                            color: _ctx.reconciliationColor(props.item),
                                            size: "small"
                                          }), {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.reconciliationIcon(props.item)), 1)
                                            ]),
                                            _: 2
                                          }, 1040, ["color"])
                                        ]),
                                        default: _withCtx(() => [
                                          _createElementVNode("span", null, _toDisplayString(_ctx.reconciliationTooltip(props.item)), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true)
                                ], 8, _hoisted_18))
                              : _createCommentVNode("", true),
                            (
                                    _ctx.currentUser.profile &&
                                    _ctx.currentUser.profile.configuration.document.statusDisplay &&
                                    _ctx.selectedCompany.solution !== 'MANAGEMENT'
                                )
                              ? (_openBlock(), _createElementBlock("td", {
                                  key: 6,
                                  class: "pr-1 text-center",
                                  onClick: _withModifiers(($event: any) => (_ctx.openDocument(props.item, true)), ["stop"])
                                }, [
                                  (
                                        !!props.item.original || _ctx.documentInZtillReceipt(props.item)
                                    )
                                    ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                        key: 0,
                                        location: "start"
                                      }, {
                                        activator: _withCtx(({ props }) => [
                                          _createVNode(_component_v_icon, _mergeProps(props, {
                                            color: "magic",
                                            size: "small"
                                          }), {
                                            default: _withCtx(() => _cache[112] || (_cache[112] = [
                                              _createTextVNode(" $oss-file ")
                                            ])),
                                            _: 2
                                          }, 1040)
                                        ]),
                                        default: _withCtx(() => [
                                          _cache[113] || (_cache[113] = _createElementVNode("span", null, "Un fichier est relié a ce document", -1))
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true)
                                ], 8, _hoisted_19))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_6)
                        ]),
                        _: 1
                      }, 8, ["headers", "items", "page", "sort-by", "sort-desc", "items-per-page", "items-length", "loading", "height"]))
                    : (_openBlock(), _createBlock(_component_v_data_table_server, {
                        key: 1,
                        header: _ctx.mailHeaders,
                        items: _ctx.mails,
                        page: _ctx.pagination.page,
                        "sort-by": _ctx.pagination.sortByMail,
                        "sort-desc": _ctx.pagination.descending,
                        "items-per-page": _ctx.pagination.rowsPerPage,
                        "items-length": _ctx.pagination.totalItems,
                        "items-per-page-options": [5, 10, 25],
                        loading: _ctx.loading,
                        class: "table rounded-lg",
                        "fixed-header": "",
                        "hide-default-footer": "",
                        height: _ctx.selectMode ? '60vh' : '76vh',
                        style: {"min-width":"1150px"}
                      }, {
                        headers: _withCtx(({ columns: mailHeaders }) => [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", {
                              colspan: _ctx.headers.length,
                              style: {"padding-left":"0"}
                            }, [
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "flex-nowrap"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    class: "d-flex justify-end align-center space-x-0 flex-grow-1 flex-shrink-0"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_select, {
                                        modelValue: _ctx.sortByMail,
                                        "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.sortByMail) = $event)),
                                        items: _ctx.sortByListMail,
                                        "hide-details": "",
                                        "item-value": "key",
                                        "item-title": "text",
                                        label: "Trier par",
                                        outlined: "",
                                        "return-object": "",
                                        density: "compact",
                                        style: {"max-width":"22%"}
                                      }, null, 8, ["modelValue", "items"]),
                                      _createVNode(_component_v_select, {
                                        modelValue: _ctx.pagination.rowsPerPage,
                                        "onUpdate:modelValue": [
                                          _cache[43] || (_cache[43] = ($event: any) => ((_ctx.pagination.rowsPerPage) = $event)),
                                          _cache[44] || (_cache[44] = ($event: any) => (_ctx.checkMaximumPage()))
                                        ],
                                        items: [5, 10, 25],
                                        "hide-details": "",
                                        outlined: "",
                                        label: "Lignes par page",
                                        density: "compact",
                                        style: {"max-width":"16%"}
                                      }, null, 8, ["modelValue"]),
                                      _createElementVNode("span", _hoisted_21, _toDisplayString((_ctx.pagination.page - 1) * _ctx.pagination.rowsPerPage + 1) + " - " + _toDisplayString((_ctx.pagination.page - 1) * _ctx.pagination.rowsPerPage +
                                                _ctx.pagination.rowsPerPage) + " de " + _toDisplayString(_ctx.pagination.totalItems), 1),
                                      _createVNode(_component_v_btn_prev, {
                                        onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.pagination.page--)),
                                        disabled: _ctx.pagination.page === 1
                                      }, null, 8, ["disabled"]),
                                      _createVNode(_component_v_btn_next, {
                                        onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.pagination.page++)),
                                        disabled: _ctx.nextPageDisabled
                                      }, null, 8, ["disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ], 8, _hoisted_20)
                          ])
                        ]),
                        "no-data": _withCtx(() => _cache[114] || (_cache[114] = [
                          _createTextVNode("Aucune mail trouvé")
                        ])),
                        item: _withCtx(({ item }) => [
                          _createElementVNode("tr", {
                            style: {"cursor":"pointer"},
                            onClick: ($event: any) => (_ctx.openMail(item)),
                            "data-cy": 'documentTable-document-' + item
                          }, [
                            (item.date)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_23, _toDisplayString(_ctx.formatDate(item.date)), 1))
                              : (_openBlock(), _createElementBlock("td", {
                                  key: 1,
                                  onClick: ($event: any) => (_ctx.openMail(item)),
                                  class: "px-0 text-center"
                                }, [
                                  _createVNode(_component_v_icon, {
                                    color: "primary",
                                    size: "large"
                                  }, {
                                    default: _withCtx(() => _cache[115] || (_cache[115] = [
                                      _createTextVNode("$dot")
                                    ])),
                                    _: 1
                                  })
                                ], 8, _hoisted_24)),
                            _createElementVNode("td", _hoisted_25, _toDisplayString("À " + _ctx.mailTo(item.to)), 1),
                            _createElementVNode("td", _hoisted_26, _toDisplayString("De " + _ctx.mailFrom(item.from)), 1),
                            _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.otherCompany(item)), 1),
                            (item.subject !== '-')
                              ? (_openBlock(), _createElementBlock("td", _hoisted_28, [
                                  _createElementVNode("div", _hoisted_29, [
                                    _createElementVNode("span", _hoisted_30, _toDisplayString(item.subject), 1),
                                    _createTextVNode(" " + _toDisplayString(item.text), 1)
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("td", {
                                  key: 3,
                                  onClick: ($event: any) => (_ctx.openMail(item)),
                                  class: "px-0 text-center"
                                }, [
                                  _createVNode(_component_v_icon, {
                                    color: "primary",
                                    size: "large"
                                  }, {
                                    default: _withCtx(() => _cache[116] || (_cache[116] = [
                                      _createTextVNode("$dot")
                                    ])),
                                    _: 1
                                  })
                                ], 8, _hoisted_31))
                          ], 8, _hoisted_22)
                        ]),
                        _: 1
                      }, 8, ["header", "items", "page", "sort-by", "sort-desc", "items-per-page", "items-length", "loading", "height"]))
                ], 64))
              : (_openBlock(), _createBlock(_component_v_row, {
                  key: 2,
                  "no-gutters": "",
                  style: {"max-height":"calc(100vh - 226px)","overflow-y":"auto"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        (!_ctx.documents.length && !_ctx.loading && _ctx.firstRequestDone)
                          ? (_openBlock(), _createBlock(_component_v_card, {
                              key: 0,
                              class: "default_card large",
                              elevation: "0"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card_title, {
                                  style: {"text-align":"center !important"},
                                  "primary-title": ""
                                }, {
                                  default: _withCtx(() => _cache[117] || (_cache[117] = [
                                    _createTextVNode("Aucun justificatif trouvé")
                                  ])),
                                  _: 1
                                }),
                                (
                                    _ctx.currentUser.profile.configuration.document.importSalesInvoice ||
                                    _ctx.currentUser.profile.configuration.document.importPurchaseInvoice
                                )
                                  ? (_openBlock(), _createBlock(_component_v_card_text, {
                                      key: 0,
                                      style: {"text-align":"center"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn, {
                                          class: "btn_card",
                                          rounded: "",
                                          onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.openDocumentWizard())),
                                          size: "small"
                                        }, {
                                          default: _withCtx(() => _cache[118] || (_cache[118] = [
                                            _createTextVNode("Ajouter")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documents, (document) => {
                      return (_openBlock(), _createBlock(_component_v_col, {
                        cols: "12",
                        class: "py-1",
                        key: document.id
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, {
                            elevation: "0",
                            class: "pa-2",
                            style: {"border-radius":"8px","min-height":"40px"},
                            onClick: ($event: any) => (_ctx.openDocument(document))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                style: {"flex-wrap":"nowrap"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { class: "mobile flex-grow-1 flex-shrink-0" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.getDocumentTitle(document, false) !== "-"
                                            ? _ctx.getDocumentTitle(document, false)
                                            : _ctx.formatType(document.type)), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  (
                                        _ctx.newCommonFormatCurrency(
                                            _ctx.grossAmountSigned(document),
                                            undefined,
                                        )
                                    )
                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                        key: 0,
                                        class: _normalizeClass(
                                        'mobile flex-grow-0 flex-shrink-1 d-flex justify-end ' +
                                        _ctx.getAmountClass(document)
                                    )
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                            _ctx.grossAmountSigned(document),
                                            undefined,
                                        )), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["class"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                style: {"flex-wrap":"nowrap"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { class: "mobile flex-grow-0 flex-shrink-1" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        color: "secondary",
                                        size: "small",
                                        location: "start"
                                      }, {
                                        default: _withCtx(() => _cache[119] || (_cache[119] = [
                                          _createTextVNode("$oss-calendar")
                                        ])),
                                        _: 1
                                      }),
                                      _createTextVNode(" " + _toDisplayString(_ctx.formatDateMobile(document.date)), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, {
                                    class: _normalizeClass(
                                        'flex-grow-1 flex-shrink-1 d-flex justify-end align-center ' +
                                        'text-' +
                                        _ctx.statusColor(document)
                                    )
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_badge, {
                                        dot: "",
                                        inline: "",
                                        color: _ctx.statusColor(document),
                                        class: "mr-1",
                                        floating: ""
                                      }, null, 8, ["color"]),
                                      _createTextVNode(" " + _toDisplayString(_ctx.statusTooltip(document)) + " ", 1),
                                      (!!document.original)
                                        ? (_openBlock(), _createBlock(_component_v_icon, {
                                            key: 0,
                                            color: "magic",
                                            size: "small",
                                            location: "end"
                                          }, {
                                            default: _withCtx(() => _cache[120] || (_cache[120] = [
                                              _createTextVNode(" $oss-file ")
                                            ])),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1032, ["class"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128)),
                    (
                            _ctx.documents &&
                            _ctx.documents.length &&
                            _ctx.documents.length < _ctx.pagination.totalItems
                        )
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: _ctx.$vuetify.display.mobile ? '12' : '10',
                          class: "d-flex px-3 justify-center"
                        }, {
                          default: _withCtx(() => [
                            _withDirectives((_openBlock(), _createBlock(_component_oss_card, { skeleton: true }, {
                              left: _withCtx(() => _cache[121] || (_cache[121] = [])),
                              _: 1
                            })), [
                              [_directive_intersect, _ctx.onIntersect]
                            ])
                          ]),
                          _: 1
                        }, 8, ["cols"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })),
            _createVNode(_component_oss_dialog, {
              modelValue: _ctx.dialogChooseDownload,
              "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.dialogChooseDownload) = $event)),
              title: "Télécharger le document",
              "max-width": "800px"
            }, {
              actions: _withCtx(() => [
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "6",
                      class: "pr-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn_primary, {
                          rounded: "",
                          block: "",
                          onClick: _cache[48] || (_cache[48] = ($event: any) => {
                                    _ctx.dialogChooseDownload = false;
                                    _ctx.downloadFile(true);
                                }),
                          size: "x-large"
                        }, {
                          default: _withCtx(() => _cache[122] || (_cache[122] = [
                            _createTextVNode("Original")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "6",
                      class: "pl-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn_primary, {
                          rounded: "",
                          block: "",
                          onClick: _cache[49] || (_cache[49] = ($event: any) => {
                                    _ctx.dialogChooseDownload = false;
                                    _ctx.downloadFile(false);
                                }),
                          size: "x-large"
                        }, {
                          default: _withCtx(() => _cache[123] || (_cache[123] = [
                            _createTextVNode("Marqué")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _cache[124] || (_cache[124] = _createTextVNode(" Voulez-vous télécharger le document original ou marqué (numéro de pièce + horodaté) ? "))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.importDocument)
        ? (_openBlock(), _createBlock(_component_DocumentWizardDialog, {
            key: 1,
            modelValue: _ctx.importDocument,
            "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.importDocument) = $event)),
            companyId: _ctx.selectedCompany.id,
            documentType: _ctx.documentTypeToUpload,
            inGlobalStep: _ctx.inGlobalStep,
            onFilesUploaded: _cache[52] || (_cache[52] = ($event: any) => (_ctx.refetchDocuments())),
            onStartMiscellaneousOperation: _cache[53] || (_cache[53] = ($event: any) => {
                _ctx.importDocument = false;
                _ctx.miscellaneousOperationDialog = true;
            }),
            onStartMiscellaneous: _cache[54] || (_cache[54] = ($event: any) => (_ctx.startUpload('MISCELLANEOUS'))),
            onStartLoanOcr: _cache[55] || (_cache[55] = ($event: any) => (_ctx.startUpload('LOAN'))),
            onClose: _cache[56] || (_cache[56] = ($event: any) => (_ctx.inGlobalStep = ''))
          }, null, 8, ["modelValue", "companyId", "documentType", "inGlobalStep"]))
        : _createCommentVNode("", true),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.stripeDialog,
        "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.stripeDialog) = $event)),
        title: "Importation Stripe",
        width: "80vw"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ImportStripe, {
            companyId: _ctx.selectedCompany.id,
            onClose: _cache[57] || (_cache[57] = ($event: any) => (_ctx.stripeDialog = false)),
            onImportDone: _ctx.onImportDone
          }, null, 8, ["companyId", "onImportDone"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.miscellaneousOperationDialog,
        "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.miscellaneousOperationDialog) = $event)),
        actions: _ctx.actionsMiscellaneousOperation,
        width: "90vw"
      }, {
        default: _withCtx(() => [
          (_ctx.miscellaneousOperationDialog)
            ? (_openBlock(), _createBlock(_component_AccountingItemEdition2, {
                key: 0,
                companyId: _ctx.selectedCompany.id,
                onUpsert: _cache[59] || (_cache[59] = ($event: any) => (_ctx.refetchDocuments())),
                actions: _ctx.actionsMiscellaneousOperation
              }, null, 8, ["companyId", "actions"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "actions"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.dialogDeleteSelectedDocument,
        "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.dialogDeleteSelectedDocument) = $event)),
        title: "Supprimer des documents",
        validTitle: "Oui, je suis sûr(e)",
        "valid-class": "error",
        onValid: _ctx.deleteDocuments,
        width: "800px"
      }, {
        default: _withCtx(() => [
          _createElementVNode("h4", _hoisted_32, " Voulez-vous supprimer " + _toDisplayString(_ctx.selectedDocumentIds.length) + " document" + _toDisplayString(_ctx.selectedDocumentIds.length === 1 ? "" : "s") + " ? ", 1)
        ]),
        _: 1
      }, 8, ["modelValue", "onValid"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.dialogDeletePermanentlySelectedDocument,
        "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.dialogDeletePermanentlySelectedDocument) = $event)),
        title: "Supprimer des documents définitivement",
        onValid: _cache[63] || (_cache[63] = ($event: any) => (_ctx.deleteDocuments(false))),
        width: "800px"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("h4", null, " Voulez-vous supprimer définitivement " + _toDisplayString(_ctx.selectedDocumentIds.length) + " document" + _toDisplayString(_ctx.selectedDocumentIds.length === 1 ? "" : "s") + " ? ", 1)
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.multiValidationDialog,
        "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.multiValidationDialog) = $event)),
        title: "Validation des justificatifs",
        onValid: _ctx.multiValidateDocuments,
        width: "800px"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("h4", null, " Voulez-vous valider " + _toDisplayString(_ctx.selectedDocumentIds.length) + " justificatif" + _toDisplayString(_ctx.selectedDocumentIds.length === 1 ? "" : "s") + " ? ", 1)
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "onValid"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.dialogChangeThirdPartyCompanyDocument,
        "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.dialogChangeThirdPartyCompanyDocument) = $event)),
        title: 
                'Modifier le ' +
                (_ctx.onlySalesSelected ? 'client' : 'fournisseur') +
                ' ' +
                (_ctx.selectedDocumentIds.length === 1
                    ? 'du document'
                    : `des ${_ctx.selectedDocumentIds.length} documents`)
            ,
        onValid: _ctx.changeThirdPartyCompany,
        validDisabled: !_ctx.newThirdPartyCompany || !_ctx.newThirdPartyCompany.id,
        width: "800px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_company_table, {
            modelValue: _ctx.newThirdPartyCompany,
            "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.newThirdPartyCompany) = $event)),
            showGenericCompany: false,
            showConsumerCompanies: _ctx.onlySalesSelected,
            showCustomerCompanies: _ctx.onlySalesSelected,
            showSupplierCompanies: _ctx.onlyPurchasesSelected,
            showExistingCompanies: false,
            showNewCompanies: true,
            parentCompanyId: _ctx.selectedCompany.id,
            wizardMode: true
          }, null, 8, ["modelValue", "showConsumerCompanies", "showCustomerCompanies", "showSupplierCompanies", "parentCompanyId"])
        ]),
        _: 1
      }, 8, ["modelValue", "title", "onValid", "validDisabled"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.widgetDialog,
        "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.widgetDialog) = $event)),
        "hide-valid": true,
        title: _ctx.activeExtension.name || '',
        width: "70vw"
      }, {
        default: _withCtx(() => [
          (_ctx.widgetDialog)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _createVNode(_component_oss_widget_embedder, _mergeProps(_ctx.activeExtension, {
                  onClose: _cache[67] || (_cache[67] = ($event: any) => (_ctx.widgetDialog = false))
                }), null, 16)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "title"]),
      (_ctx.activeSaleInvoices)
        ? (_openBlock(), _createBlock(_component_SalesInvoice, {
            key: 2,
            modelValue: _ctx.activeSaleInvoices,
            "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.activeSaleInvoices) = $event)),
            onSalesInvoiceImported: _cache[70] || (_cache[70] = ($event: any) => (_ctx.imported()))
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.uploadDocumentsFromMailDialog)
        ? (_openBlock(), _createBlock(_component_upload_documents_from_mail, {
            key: 3,
            modelValue: _ctx.uploadDocumentsFromMailDialog,
            "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.uploadDocumentsFromMailDialog) = $event)),
            onAttachmentUploaded: _ctx.refetchDocuments
          }, null, 8, ["modelValue", "onAttachmentUploaded"]))
        : _createCommentVNode("", true),
      (_ctx.subscriptionsDialog)
        ? (_openBlock(), _createBlock(_component_Subscriptions, {
            key: 4,
            modelValue: _ctx.subscriptionsDialog,
            "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.subscriptionsDialog) = $event)),
            companyId: _ctx.selectedCompany.id,
            onSubscriptionUpserted: _ctx.refetchDocuments
          }, null, 8, ["modelValue", "companyId", "onSubscriptionUpserted"]))
        : _createCommentVNode("", true),
      _createVNode(_component_ImportBankMain, {
        modelValue: _ctx.importBankDialog,
        "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((_ctx.importBankDialog) = $event)),
        onBankTransactionImported: _cache[74] || (_cache[74] = ($event: any) => (_ctx.refresh()))
      }, null, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["style"]))
}